import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface AuthRedirectProps {
  children: React.ReactNode;
}

export const AuthRedirect: React.FC<AuthRedirectProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  // sessionStorage에 실제 토큰이 있는지도 확인
  // isAuthenticated만으로는 Zustand localStorage 상태가 stale할 수 있음
  const hasToken = !!sessionStorage.getItem('access_token');

  // 로그인된 상태이고 실제 토큰이 있을 때만 모니터링 페이지로 리다이렉트
  if (isAuthenticated && hasToken) {
    return <Navigate to="/monitoring/realtime" replace />;
  }

  return <>{children}</>;
};
